import { render, staticRenderFns } from "./LocationTableChair.vue?vue&type=template&id=3e759c37"
import script from "./LocationTableChair.vue?vue&type=script&lang=js"
export * from "./LocationTableChair.vue?vue&type=script&lang=js"
import style0 from "./LocationTableChair.vue?vue&type=style&index=0&id=3e759c37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports